import AuxButton from './AuxButton';
import BackButton from './BackButton';
import Footer from './Footer';
import NextButton from './NextButton';

export default Footer;
export { AuxButton, BackButton, NextButton };
